/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopPhaseParticipantRole'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./WorkshopPhaseParticipantRole'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopPhaseReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopPhaseParticipantRole);
  }
}(this, function(ApiClient, WorkshopPhaseParticipantRole) {
  'use strict';




  /**
   * The WorkshopPhaseReport model module.
   * @module model/WorkshopPhaseReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopPhaseReport</code>.
   * @alias module:model/WorkshopPhaseReport
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>WorkshopPhaseReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopPhaseReport} obj Optional instance to populate.
   * @return {module:model/WorkshopPhaseReport} The populated <code>WorkshopPhaseReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ParticipantRoles')) {
        obj['ParticipantRoles'] = ApiClient.convertToType(data['ParticipantRoles'], [WorkshopPhaseParticipantRole]);
      }
      if (data.hasOwnProperty('WorkshopID')) {
        obj['WorkshopID'] = ApiClient.convertToType(data['WorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('HasDeadline')) {
        obj['HasDeadline'] = ApiClient.convertToType(data['HasDeadline'], 'Boolean');
      }
      if (data.hasOwnProperty('DeadlineStartDate')) {
        obj['DeadlineStartDate'] = ApiClient.convertToType(data['DeadlineStartDate'], 'Date');
      }
      if (data.hasOwnProperty('DeadlineEndDate')) {
        obj['DeadlineEndDate'] = ApiClient.convertToType(data['DeadlineEndDate'], 'Date');
      }
      if (data.hasOwnProperty('IsPublished')) {
        obj['IsPublished'] = ApiClient.convertToType(data['IsPublished'], 'Boolean');
      }
      if (data.hasOwnProperty('PausedAt')) {
        obj['PausedAt'] = ApiClient.convertToType(data['PausedAt'], 'Date');
      }
      if (data.hasOwnProperty('ResultSummary')) {
        obj['ResultSummary'] = ApiClient.convertToType(data['ResultSummary'], 'String');
      }
      if (data.hasOwnProperty('TemplateDefaultPublicationStatus')) {
        obj['TemplateDefaultPublicationStatus'] = ApiClient.convertToType(data['TemplateDefaultPublicationStatus'], 'Boolean');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CustomBackgroundImageBlobStorageUrl')) {
        obj['CustomBackgroundImageBlobStorageUrl'] = ApiClient.convertToType(data['CustomBackgroundImageBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('IsClosed')) {
        obj['IsClosed'] = ApiClient.convertToType(data['IsClosed'], 'Boolean');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/WorkshopPhaseParticipantRole>} ParticipantRoles
   */
  exports.prototype['ParticipantRoles'] = undefined;
  /**
   * @member {Integer} WorkshopID
   * @default 0
   */
  exports.prototype['WorkshopID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} HasDeadline
   * @default false
   */
  exports.prototype['HasDeadline'] = false;
  /**
   * @member {Date} DeadlineStartDate
   */
  exports.prototype['DeadlineStartDate'] = undefined;
  /**
   * @member {Date} DeadlineEndDate
   */
  exports.prototype['DeadlineEndDate'] = undefined;
  /**
   * @member {Boolean} IsPublished
   * @default false
   */
  exports.prototype['IsPublished'] = false;
  /**
   * @member {Date} PausedAt
   */
  exports.prototype['PausedAt'] = undefined;
  /**
   * @member {String} ResultSummary
   * @default ''
   */
  exports.prototype['ResultSummary'] = '';
  /**
   * @member {Boolean} TemplateDefaultPublicationStatus
   * @default false
   */
  exports.prototype['TemplateDefaultPublicationStatus'] = false;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {String} CustomBackgroundImageBlobStorageUrl
   * @default ''
   */
  exports.prototype['CustomBackgroundImageBlobStorageUrl'] = '';
  /**
   * @member {Boolean} IsClosed
   * @default false
   */
  exports.prototype['IsClosed'] = false;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


